import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { DistrictProvider } from './context/DistrictContext';
import { AuthProvider } from './context/AuthContext';
import Header from './components/common/Header';
import Dashboard from './components/Dashboard/Dashboard';
import StudentDetail from './components/StudentDetail/StudentDetail';
import Survey from './components/Survey/Survey';
import Reports from './components/Reports/Reports';
import Institutes from './components/Institutes/Institutes';
import Roster from './components/Roster/Roster';
import AccessAssignments from './components/Access/AccessAssignments';
import Login from './components/Auth/Login';
import Embed from './pages/Embed';
import ProtectedRoute from './components/Auth/ProtectedRoute';
import SuperAdminRoute from './components/Auth/SuperAdminRoute';
import DistrictAdminRoute from './components/Auth/DistrictAdminRoute';

// Layout wrapper to conditionally show Header
function Layout({ children }) {
  const location = useLocation();
  const isEmbedPage = location.pathname === '/embed';

  return (
    <div className="min-h-screen bg-gray-50">
      {!isEmbedPage && <Header />}
      {children}
    </div>
  );
}

function App() {
  return (
    <DistrictProvider>
      <AuthProvider>
        <Router>
          <Layout>
            <Routes>
              {/* Public Routes */}
              <Route path="/login" element={<Login />} />
              <Route path="/survey" element={<Survey />} />
              <Route path="/embed" element={<Embed />} />

              {/* Protected Routes */}
              <Route
                path="/"
                element={
                  <ProtectedRoute>
                    <Dashboard />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/reports"
                element={
                  <ProtectedRoute>
                    <Reports />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/institutes"
                element={
                  <SuperAdminRoute>
                    <Institutes />
                  </SuperAdminRoute>
                }
              />
              <Route
                path="/roster"
                element={
                  <DistrictAdminRoute>
                    <Roster />
                  </DistrictAdminRoute>
                }
              />
              <Route
                path="/access"
                element={
                  <DistrictAdminRoute>
                    <AccessAssignments />
                  </DistrictAdminRoute>
                }
              />
              <Route
                path="/student/:studentID"
                element={
                  <ProtectedRoute>
                    <StudentDetail />
                  </ProtectedRoute>
                }
              />
            </Routes>
          </Layout>
        </Router>
      </AuthProvider>
    </DistrictProvider>
  );
}

export default App;
